import { ChevronLeftOutlined, ChevronRightOutlined } from '@material-ui/icons';
import styled from 'styled-components';

export const ChevronLeftOutlinedStyled = styled(ChevronLeftOutlined)``;
export const ChevronRightStyled = styled(ChevronRightOutlined)``; 
